import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    style: {
      zIndex: _vm.options.zIndex
    },
    attrs: {
      persistent: "",
      "max-width": _vm.options.width
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.cancel.apply(null, arguments);
      }
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    attrs: {
      disabled: _vm.validating
    },
    on: {
      click: _vm.internalCancel
    }
  })], 1), _c(VCardTitle, {
    staticClass: "pb-0"
  }, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v("Refund / Close (" + _vm._s(_vm.creditNote.numberLabel) + ")")])]), _c("section", {
    staticClass: "content"
  }, [_c("div", [_c("div", {
    staticClass: "required"
  }, [_vm._v("Note")]), _c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      placeholder: "...",
      required: "",
      rules: [_vm.rules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.refundingNote,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "refundingNote", $$v);
      },
      expression: "form.refundingNote"
    }
  })], 1), _c("div", [_c("div", {
    staticClass: "required"
  }, [_vm._v("Refund date")]), _c(VMenu, {
    attrs: {
      "close-on-content-click": false,
      transition: "scale-transition",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c(VTextField, _vm._g(_vm._b({
          staticClass: "v-text-field-no-label",
          attrs: {
            type: "date",
            required: "",
            rules: [_vm.rules.mustNotBeEmpty],
            "hide-details": "auto"
          },
          model: {
            value: _vm.form.date,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "date", $$v);
            },
            expression: "form.date"
          }
        }, "v-text-field", attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.dateMenu,
      callback: function callback($$v) {
        _vm.dateMenu = $$v;
      },
      expression: "dateMenu"
    }
  }, [_c(VDatePicker, {
    on: {
      input: function input($event) {
        _vm.dateMenu = false;
      }
    },
    model: {
      value: _vm.form.date,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "date", $$v);
      },
      expression: "form.date"
    }
  })], 1)], 1), _c("div", [_c("div", [_vm._v("Amount (" + _vm._s(_vm.getSymbolCurrency(this.creditNote.initialCurrency)) + ")")]), _c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      placeholder: "0.00",
      type: "number",
      min: "0.01",
      max: this.creditNote.remaining.amountCurrency,
      required: "",
      rules: [_vm.rules.mustBeGreaterThan0],
      "hide-details": "auto"
    },
    on: {
      blur: _vm.changeAmountCurrency
    },
    model: {
      value: _vm.form.amountCurrency,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "amountCurrency", $$v);
      },
      expression: "form.amountCurrency"
    }
  })], 1), _c("div", {
    staticClass: "tip"
  }, [_c("i", {
    staticClass: "fas fa-lightbulb pr-2"
  }), _vm._v(" In case of refunding, thanks to upload the proof in the attached files. ")])]), _c(VCardActions, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: "",
      disabled: _vm.validating
    },
    nativeOn: {
      click: function click($event) {
        return _vm.internalCancel.apply(null, arguments);
      }
    }
  }, [_vm._v(" Cancel ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: "",
      loading: _vm.validating,
      disabled: _vm.isInvalidForm
    },
    nativeOn: {
      click: function click($event) {
        return _vm.agree.apply(null, arguments);
      }
    }
  }, [_vm._v(" Confirm ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };